// notificationService.js

// Helper function to generate resident notice text
const generateResidentNotice = (booking, property) => {
  return `
    <p style="background: #d4edda; padding: 15px; border-radius: 8px; border: 1px solid #c3e6cb;">
      This notice is served upon you at least twenty-four (24) hours prior to the stated date and time of entry, as required by California Civil Code Section 1954.
    </p>
    
    <h3>Notice of Intent to Enter</h3>
    
    <p>Property: ${property.address_line1}</p>
    <p>Date: ${new Date(booking.showing_date).toLocaleDateString()}</p>
    <p>Time: ${booking.showing_time}</p>
    <p>Duration: 30 minutes</p>
    <p>Purpose: To show the property to prospective buyer/renter</p>
    
    <p>This serves as your notice that an agent will enter the property at the specified date and time.</p>
  `;
};

// Send all booking notifications (email, SMS, mail)
const sendBookingNotifications = async (booking, property) => {
  try {
    // Check if notifications are enabled
    if (!process.env.REACT_APP_ENABLE_NOTIFICATIONS) {
      console.log('ℹ️ Notifications disabled - skipping notification send');
      return {
        success: true,
        skipped: true,
        message: 'Notifications are disabled'
      };
    }

    console.log('🔔 Sending booking notifications...');
    
    // Make API call to send notifications
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/notifications/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        booking,
        property,
        noticeText: generateResidentNotice(booking, property)
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('✅ Notifications sent successfully:', result);
    return result;

  } catch (error) {
    console.error('❌ Failed to send notifications:', error);
    // Don't throw error - we don't want failed notifications to break the booking flow
    return {
      success: false,
      error: error.message
    };
  }
};

export default {
  sendBookingNotifications
};